import React from 'react';
import PropTypes from 'prop-types';
import {
  manualInstructorReviewsPropTypes,
  manualUserVenuesPropTypes,
  msiLastChangePropTypes,
} from 'constants/propTypes';
import _isEmpty from 'lodash/isEmpty';
import LoadingDots from 'components/LoadingDots';
import Message from 'components/Message';
import { messages } from '../Instructors.messages';

import InstructorDetailsDescription from './InstructorDetailsDescription';
import InstructorDetailsHeader from './InstructorDetailsHeader';

import './InstructorDetails.scss';

const InstructorDetails = ({ instructor, venues, isLoading, instagramService, venueId }) => {
  if (isLoading) {
    return (
      <div className="instructor-details__loader">
        <LoadingDots />
      </div>
    );
  }

  if (_isEmpty(instructor)) {
    return <Message as="div" className="instructor-details__empty" message={messages.details.selectInstructor} />;
  }

  const { firstName, lastName, pictureUrl, email, phone, bio, certifications, id, venueIds, lastChange } = instructor;

  return (
    <div className="instructor-details" data-cypress="instructor-details">
      <div className="grid grid--flush">
        <InstructorDetailsHeader
          venueId={venueId}
          firstName={firstName}
          lastName={lastName}
          pictureUrl={pictureUrl}
          instructorId={id}
        />
      </div>
      <div className="grid grid--flush">
        <div className="instructor-details__container">
          <InstructorDetailsDescription
            email={email}
            bio={bio}
            socialHandle={instagramService}
            phone={phone}
            certifications={certifications}
            venues={venues}
            instructorVenueIds={venueIds}
            lastChange={lastChange}
          />
        </div>
      </div>
    </div>
  );
};

InstructorDetails.propTypes = {
  instructor: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    picture: PropTypes.string,
    email: PropTypes.string,
    bio: PropTypes.string,
    certifications: PropTypes.string,
    id: PropTypes.number,
    pictureUrl: PropTypes.string,
    socialHandles: PropTypes.arrayOf(
      PropTypes.shape({
        service: PropTypes.string,
        displayName: PropTypes.string,
        userName: PropTypes.string,
      })
    ),
    phone: PropTypes.string,
    reviews: manualInstructorReviewsPropTypes,
    ratingsAverage: PropTypes.number,
    ratingsCount: PropTypes.number,
    classesTaughtCount: PropTypes.number,
    substitutionsCount: PropTypes.number,
    venueIds: PropTypes.arrayOf(PropTypes.number),
    venues: PropTypes.arrayOf(
      PropTypes.shape({
        venue_id: PropTypes.number,
        name: PropTypes.string,
      })
    ),
    lastChange: msiLastChangePropTypes,
  }),
  venues: manualUserVenuesPropTypes,
  venueId: PropTypes.number,
  id: PropTypes.number,
  isLoading: PropTypes.bool,
  instagramService: PropTypes.shape({
    userName: PropTypes.string,
  }),
};

export default InstructorDetails;
